const state = {
    name:'', //真实姓名
    userName: '',//用户名
    roleName: '', //角色名
    roleType:'',//类型
    roleId:'', //角色ID
    parallelUserName:"", //并行用户名
    realName:"",//真实姓名
    mobile:"", // 手机号
    email:"", // 邮箱
    customerType:'', //客户类型
        
    crumbsArr:[{name:'首页',url:'/home'}], //面包屑路径
    menu:[], //路由
    jumpMenu:{}, //页面内的路由跳转
    logUrl:'', //存储跳转地址
    buttons:[], // 页面按钮集合
    menuWidth:'' ,//aside的宽度
    tokens:'', // token值
    shopping:{},// 购物详情
    subUser:'' , //子用户
    cardRenewal:{}, //物联网卡续费条件
    orderInfo:'', // 订单信息，订单模块使用的订单id，通道号，商品ID
    cardIccid:'', //单池卡，语音卡通过ICCID 跳转页面使用
    userPoolCard:{}, // 用户池信息
    routeList:[], //路由表
    visitedViews: [],//Tabs视图
    cachedViews: [], //需要缓存视图
    contractNumber:'', //合同编号

    JumpParams:{}, //跳转带参
};
export default state;


// WEBPACK FOOTER //
// ./src/store/state.js